export const cortarTexto = (texto, fin) => {
  if (!texto) return "";
  if (texto.length < fin) return texto;
  return texto.substring(0, fin) + " -";
};
